/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const LeaderBoardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={28}
    height={30}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="LeaderBoardIcon">
    <path
      d="M13.552 1.158a.5.5 0 0 1 .896 0l1.089 2.206a.5.5 0 0 0 .376.273l2.434.354a.5.5 0 0 1 .277.853l-1.76 1.717a.5.5 0 0 0-.145.442l.416 2.424a.5.5 0 0 1-.725.527L14.233 8.81a.5.5 0 0 0-.466 0L11.59 9.954a.5.5 0 0 1-.725-.527l.416-2.424a.5.5 0 0 0-.144-.442L9.376 4.844a.5.5 0 0 1 .277-.853l2.434-.354a.5.5 0 0 0 .376-.273l1.089-2.206Z"
      stroke="#2894F9"
      strokeWidth={1.25}
    />
    <path
      d="M.875 21.887a1 1 0 0 1 1-1h6.75a1 1 0 0 1 1 1v7.136H.875v-7.136ZM9.625 13.75a1 1 0 0 1 1-1h6.75a1 1 0 0 1 1 1v15.273h-8.75V13.75ZM18.375 18.4a1 1 0 0 1 1-1h6.75a1 1 0 0 1 1 1v10.623h-8.75V18.4Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

export default LeaderBoardIcon;
